import React from 'react';

const RedHatCertificationTraining = () => (
  <div className="py-16 bg-gradient-to-b from-gray-50 to-gray-100 min-h-screen">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-extrabold text-gray-800 mb-8" data-aos="fade-up">
          Red Hat Certification Training & Enablement
        </h1>
        <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 border-l-4 border-blue-600" data-aos="fade-up" data-aos-delay="100">
          <p className="text-lg text-gray-700 mb-6">
            Prepare for Red Hat certifications with our tailored training and enablement programs. Our instructors provide hands-on labs, exam preparation, and real-world scenarios to help you succeed.
          </p>
          <ul className="list-disc ml-8 mb-6 text-gray-700">
            <li>Red Hat OpenShift and Linux certification tracks</li>
            <li>Hands-on labs and workshops</li>
            <li>Exam readiness and coaching</li>
            <li>Corporate training solutions</li>
          </ul>
          <p className="text-gray-700">
            Advance your career with industry-recognized certifications.
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default RedHatCertificationTraining;
